import { useNavigator } from '@repo/toolkit/use-navigator'
import Box from '@repo/ui/box'
import { BusIcon } from '@repo/ui/icons'
import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'

import { createRad } from '../../api/rads/create-rad'
import UserNavBar from '../../components/elements/nav-bar'
import RadForm from '../../components/pages/rads/rad-form'
import { Paths } from '../../lib/constants/path'
import { twoButtonsConfig } from '../../lib/utils/buttons-config/validation-buttons-config'
import { showAxiosError } from '../../lib/utils/functions/misc.functions'

const RadCreatePage = () => {
  const { back, navigate } = useNavigator()

  const { mutateAsync } = useMutation({
    mutationFn: createRad,
    onError: showAxiosError,
    onSuccess: () => toast.success('Réunion avant départ créée avec succès')
  })

  return (
    <div>
      <UserNavBar title={'Créer une réunion avant départ'} icon={BusIcon} />
      <div className={'h-4'} />

      <Box>
        <RadForm
          buttonsConfig={twoButtonsConfig({
            onConfirm: async (values) => {
              const res = await mutateAsync(values)
              navigate(Paths.RAD_UPDATE_PAGE.replace(':id', res.id.toString()), { replace: true })
            },
            onCancel: () => back()
          })}
        />
      </Box>
    </div>
  )
}

export default RadCreatePage
